import { numberFormatter } from '@h20-shared/utils/number-format-utils';

const NUMBER_FORMAT: Intl.NumberFormatOptions = { maximumFractionDigits: 2 };

/** The numbers as the cell shows them, like `2 / 5` for two numbers or `1 | 4 | 2` for three. */
export function formatMultiValue(
    numbers: readonly number[],
    locale: string,
    customSeparator: string | undefined
): string {
    const formatter = numberFormatter(locale, NUMBER_FORMAT);
    const separator = customSeparator ?? (numbers.length > 2 ? '|' : '/');
    return numbers.map((number) => formatter.format(number)).join(` ${separator} `);
}
